import React from "react";
import GroupVideo from "../../components/group-video";
const GroupStudy = () => {

  return <>
    <div id="explore">Group study page</div>
    <GroupVideo />
  </>;
};

export default GroupStudy;
